// import React, { useState, useEffect, useRef } from 'react';
// import { Printer, ChevronLeft, ChevronRight, Edit2, Save, X } from 'lucide-react';
// import { useLanguage } from '../../StoreContext/LanguageContext';
// import apiService from '../../config';

// const PlotAllotmentLetter = () => {
//     const { language, translations } = useLanguage();
//     const printRef = useRef(null);

//     // Project and Proposal IDs
//     const [currentProjectId, setCurrentProjectId] = useState(null);
//     const [currentProposalId, setCurrentProposalId] = useState(null);

//     // Data states
//     const [chitthiData, setChitthiData] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // Pagination (4 chitthi per page)
//     const [currentPage, setCurrentPage] = useState(0);
//     const chitthiPerPage = 4;

//     // Edit date states
//     const [editingDateIndex, setEditingDateIndex] = useState(null);
//     const [editDateValue, setEditDateValue] = useState('');

//     // Get Project and Proposal IDs
//     useEffect(() => {
//         const getProjectInfo = () => {
//             const selectedProject = localStorage.getItem('selectedProject');
//             if (selectedProject) {
//                 try {
//                     const project = JSON.parse(selectedProject);
//                     return project.project_id || project.id;
//                 } catch (e) {
//                     console.error('Error parsing selectedProject:', e);
//                 }
//             }

//             const userData = localStorage.getItem('userData');
//             if (userData) {
//                 try {
//                     const user = JSON.parse(userData);
//                     return user.data?.project_id || user.project_id;
//                 } catch (e) {
//                     console.error('Error parsing userData:', e);
//                 }
//             }
//             return null;
//         };

//         const getProposalInfo = () => {
//             const userData = localStorage.getItem('userData');
//             if (userData) {
//                 try {
//                     const user = JSON.parse(userData);
//                     return user?.data?.default_proposal || user?.data?.proposal_id || user?.default_proposal || user?.proposal_id || null;
//                 } catch (e) {
//                     console.error('Error parsing userData for proposal:', e);
//                 }
//             }
//             return null;
//         };

//         setCurrentProjectId(getProjectInfo());
//         setCurrentProposalId(getProposalInfo());
//     }, []);

//     // Fetch Chitthi Data
//     useEffect(() => {
//         if (currentProjectId && currentProposalId) {
//             fetchChitthiData();
//         }
//     }, [currentProjectId, currentProposalId]);

//     const fetchChitthiData = async () => {
//         try {
//             setLoading(true);
//             const response = await apiService.getRehabA(currentProjectId, currentProposalId);

//             console.log("✅ Chitthi API Response:", response);

//             // Transform data for chitthi
//             const transformedData = response.map((item, index) => ({
//                 id: item.rehab_id,
//                 chitthiNo: index + 1,
//                 plotNo: item.plot_no,
//                 plotSize: item.plot_size,
//                 areaSqMtr: item.area_sq_mtr,
//                 date: item.latter_date || new Date().toISOString().split('T')[0],
//                 villageName: item.village_name,
//                 talukaName: item.taluka_name,
//                 districtName: item.district_name,
//                 baseVillageName: item.base_village_name,
//                 baseTalukaName: item.base_taluka_name,
//                 baseDistrictName: item.base_district_name,
//                 ownerName: item.owner_name || ''
//             }));

//             setChitthiData(transformedData);
//         } catch (error) {
//             console.error('Error fetching chitthi data:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Handle date edit
//     const handleEditDate = (index) => {
//         setEditingDateIndex(index);
//         setEditDateValue(chitthiData[index].date);
//     };

//     const handleSaveDate = async () => {
//         if (editingDateIndex === null) return;

//         try {
//             const chitthi = chitthiData[editingDateIndex];

//             const payload = {
//                 latter_date: editDateValue
//             };

//             await apiService.patchUpdateRehabA(chitthi.id, payload);

//             // update UI after success
//             const updatedData = [...chitthiData];
//             updatedData[editingDateIndex].date = editDateValue;
//             setChitthiData(updatedData);

//             setEditingDateIndex(null);
//             setEditDateValue('');
//             alert('दिनांक यशस्वीरीत्या जतन करण्यात आली आहे');

//         } catch (error) {
//             console.error('❌ Date update failed:', error);
//             alert('दिनांक अपडेट करण्यात अडचण आली');
//         }
//     };

//     const handleCancelEdit = () => {
//         setEditingDateIndex(null);
//         setEditDateValue('');
//     };

//     // Format date to Marathi
//     const formatMarathiDate = (dateString) => {
//         if (!dateString) return '';
//         const date = new Date(dateString);
//         const day = date.getDate().toString().padStart(2, '0');
//         const month = (date.getMonth() + 1).toString().padStart(2, '0');
//         const year = date.getFullYear();
//         return `${day}/${month}/${year}`;
//     };

//     // Handle Print
//     const handlePrint = () => {
//         const printContent = printRef.current?.innerHTML;
//         if (!printContent) {
//             alert("No content available to print.");
//             return;
//         }

//         const win = window.open("", "", "height=900,width=1200");
//         win.document.write(`
//       <html>
//         <head>
//           <title>भूखंडवाटपाची चिट्ठी</title>
//           <style>
//             @page {
//               size: A4 portrait;
//               margin: 0;
//             }
            
//             body {
//               font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
//               font-size: 13px;
//               line-height: 1.4;
//               color: #000;
//               margin: 0;
//               padding: 0;
//             }

//             .page {
//               width: 210mm;
//               height: 297mm;
//               padding: 10mm;
//               box-sizing: border-box;
//               page-break-after: always;
//               display: grid;
//               grid-template-columns: 1fr 1fr;
//               grid-template-rows: 1fr 1fr;
//               gap: 5mm;
//             }

//             .page:last-child {
//               page-break-after: auto;
//             }

//             .chitthi-box {
//               border: 2px solid #000;
//               padding: 8px;
//               display: flex;
//               flex-direction: column;
//               justify-content: space-between;
//               box-sizing: border-box;
//             }

//             .text-center {
//               text-align: center;
//             }

//             .text-right {
//               text-align: right;
//             }

//             .font-bold {
//               font-weight: bold;
//             }

//             .mt-2 {
//               margin-top: 8px;
//             }

//             .mt-4 {
//               margin-top: 12px;
//             }

//             .mb-2 {
//               margin-bottom: 8px;
//             }

//             .no-print {
//               display: none !important;
//             }

//             @media print {
//               body {
//                 print-color-adjust: exact;
//                 -webkit-print-color-adjust: exact;
//               }
              
//               .no-print {
//                 display: none !important;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//         </body>
//       </html>
//     `);

//         win.document.close();
//         win.print();
//     };

//     // Calculate total pages
//     const totalPages = Math.ceil(chitthiData.length / chitthiPerPage);

//     // Get current page chitthi (4 per page)
//     const getCurrentPageChitthi = () => {
//         const startIndex = currentPage * chitthiPerPage;
//         const endIndex = startIndex + chitthiPerPage;
//         return chitthiData.slice(startIndex, endIndex);
//     };

//     // Handle pagination
//     const handlePrevious = () => {
//         if (currentPage > 0) {
//             setCurrentPage(currentPage - 1);
//         }
//     };

//     const handleNext = () => {
//         if (currentPage < totalPages - 1) {
//             setCurrentPage(currentPage + 1);
//         }
//     };

//     const currentPageChitthi = getCurrentPageChitthi();

//     return (
//         <div className="max-w-7xl mx-auto p-6">
//             {/* Action Buttons */}
//             <div className="flex justify-between items-center mb-6">
//                 <div className="flex items-center gap-4">
//                     <button
//                         onClick={handlePrevious}
//                         disabled={currentPage === 0}
//                         className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
//                     >
//                         <ChevronLeft size={20} />
//                         Previous
//                     </button>

//                     <span className="text-lg font-semibold">
//                         Page {currentPage + 1} of {totalPages} ({chitthiData.length} चिट्ठी)
//                     </span>

//                     <button
//                         onClick={handleNext}
//                         disabled={currentPage === totalPages - 1}
//                         className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
//                     >
//                         Next
//                         <ChevronRight size={20} />
//                     </button>
//                 </div>

//                 <button
//                     onClick={handlePrint}
//                     className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg"
//                 >
//                     <Printer size={20} />
//                     Print All
//                 </button>
//             </div>

//             {/* Loading State */}
//             {loading && (
//                 <div className="text-center py-10">
//                     <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//                     <p className="mt-4 text-gray-600">Loading चिट्ठी...</p>
//                 </div>
//             )}

//             {/* Chitthi Preview - 4 per page in 2x2 grid */}
//             {!loading && chitthiData.length > 0 && (
//                 <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
//                     <div
//                         ref={printRef}
//                         style={{
//                             fontFamily: "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif",
//                         }}
//                     >
//                         {/* Generate pages with 4 chitthi each */}
//                         {Array.from({ length: totalPages }).map((_, pageIndex) => {
//                             const pageChitthi = chitthiData.slice(
//                                 pageIndex * chitthiPerPage,
//                                 (pageIndex + 1) * chitthiPerPage
//                             );

//                             return (
//                                 <div
//                                     key={pageIndex}
//                                     className="page"
//                                     style={{
//                                         display: pageIndex === currentPage ? 'grid' : 'none',
//                                         width: '297mm',
//                                         height: '210mm',
//                                         padding: '8mm',
//                                         boxSizing: 'border-box',
//                                         gridTemplateColumns: '1fr 1fr',
//                                         gridTemplateRows: '1fr 1fr',
//                                         gap: '8mm'
//                                     }}
//                                 >
//                                     {pageChitthi.map((chitthi, index) => {
//                                         const globalIndex = pageIndex * chitthiPerPage + index;
//                                         return (
//                                             <div
//                                                 key={chitthi.id}
//                                                 className="chitthi-box"
//                                                 style={{
//                                                     border: '3px solid #000',
//                                                     padding: '12px',
//                                                     display: 'flex',
//                                                     flexDirection: 'column',
//                                                     justifyContent: 'space-between',
//                                                     fontSize: '13px',
//                                                     lineHeight: '1.6'
//                                                 }}
//                                             >
//                                                 <div>

//                                                     {/* LINE 1 — RIGHT TOP (BASE TALUKA + DISTRICT FROM API) */}
//                                                     {/* <div
//                                                         style={{
//                                                             textAlign: 'right',
//                                                             fontSize: '13px',
//                                                             marginBottom: '6px'
//                                                         }}
//                                                     >
//                                                         ता. {chitthi.baseTalukaName} जि. {chitthi.baseDistrictName}
//                                                     </div> */}

//                                                     {/* LINE 2 — CENTER (BASE VILLAGE + STATIC TEXT) */}
//                                                     <div
//                                                         style={{
//                                                             textAlign: 'center',
//                                                             fontSize: '13px',
//                                                             marginBottom: '6px'
//                                                         }}
//                                                     >
//                                                         मौजे {chitthi.baseVillageName} ता. {chitthi.baseTalukaName}  जि. {chitthi.baseDistrictName} येथील प्रकल्पग्रस्तांना भूखंड वाटप.
//                                                     </div>

//                                                     {/* LINE 3 — CENTER (NEW RESETTLEMENT VILLAGE) */}
//                                                     <div
//                                                         style={{
//                                                             textAlign: 'center',
//                                                             fontSize: '13px',
//                                                             marginBottom: '6px'
//                                                         }}
//                                                     >
//                                                         नवीन पुनर्वसित गावठाण – मौजे {chitthi.villageName} ता. {chitthi.talukaName} जि. {chitthi.districtName}
//                                                     </div>

//                                                     {/* LINE 4 — DATE (RIGHT, EDITABLE) */}
//                                                     <div
//                                                         style={{
//                                                             textAlign: 'center',
//                                                             fontSize: '13px',
//                                                             marginBottom: '10px'
//                                                         }}
//                                                     >
//                                                         {editingDateIndex === globalIndex ? (
//                                                             <span className="no-print">
//                                                                 दिनांक :
//                                                                 <input
//                                                                     type="date"
//                                                                     value={editDateValue}
//                                                                     onChange={(e) => setEditDateValue(e.target.value)}
//                                                                     style={{ marginLeft: '6px', fontSize: '12px' }}
//                                                                 />
//                                                                 <button onClick={handleSaveDate}><Save size={14} /></button>
//                                                                 <button onClick={handleCancelEdit}><X size={14} /></button>
//                                                             </span>
//                                                         ) : (
//                                                             <>
//                                                                 दिनांक : {formatMarathiDate(chitthi.date)}
//                                                                 <button
//                                                                     onClick={() => handleEditDate(globalIndex)}
//                                                                     className="no-print"
//                                                                     style={{ marginLeft: '6px' }}
//                                                                 >
//                                                                     <Edit2 size={14} />
//                                                                 </button>
//                                                             </>
//                                                         )}
//                                                     </div>

//                                                     {/* LINE 5 — BIG BOLD CENTER (PLOT + AREA) */}
//                                                     <div style={{ textAlign: 'center', margin: '14px 0' }}>
//                                                         <div style={{ fontSize: '26px', fontWeight: 'bold' }}>
//                                                             भूखंड क्रमांक {chitthi.plotNo} क्षेत्रफळ {Number(chitthi.areaSqMtr).toFixed(2)} चौ.मी.
//                                                         </div>
//                                                     </div>

//                                                 </div>


//                                                 {/* Bottom: Left and Right Side Static Text */}
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'space-between',
//                                                     marginTop: '20px',
//                                                     fontSize: '12px'
//                                                 }}>
//                                                     {/* Left Side */}
//                                                     <div style={{ textAlign: 'left' }}>
//                                                         <div>भूखंड घेणाऱ्याची सही/अंगठा
//                                                         </div>
//                                                         {/* <div style={{ fontWeight: 'bold', marginTop: '4px' }}>
//                                                             बुलढाणा
//                                                         </div> */}
//                                                     </div>

//                                                     {/* Right Side */}
//                                                     <div style={{ textAlign: 'right' }}>
//                                                         {/* <div style={{ fontWeight: 'bold' }}> */}
//                                                         जिल्हा पुनर्वसन अधिकारी
//                                                         {/* </div> */}
//                                                         <div style={{ textAlign: 'center', marginTop: '4px' }}>
//                                                             {chitthi.district_name || "बुलढाणा"}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         );
//                                     })}

//                                     {/* Fill empty slots if less than 4 chitthi on last page */}
//                                     {pageChitthi.length < 4 &&
//                                         Array.from({ length: 4 - pageChitthi.length }).map((_, i) => (
//                                             <div
//                                                 key={`empty-${i}`}
//                                                 style={{
//                                                     border: '2px dashed #ccc',
//                                                     padding: '8px'
//                                                 }}
//                                             />
//                                         ))}
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             )}

//             {/* No Data State */}
//             {!loading && chitthiData.length === 0 && (
//                 <div className="text-center py-10">
//                     <p className="text-gray-600 text-lg">कोणतीही चिट्ठी उपलब्ध नाही</p>
//                 </div>
//             )}

//         </div>
//     );
// };

// export default PlotAllotmentLetter;

import React, { useState, useEffect, useRef } from 'react';
import { Printer, ChevronLeft, ChevronRight, Edit2, Save, X } from 'lucide-react';
import { useLanguage } from '../../StoreContext/LanguageContext';
import apiService from '../../config';

const PlotAllotmentLetter = () => {
    const { language, translations } = useLanguage();
    const printRef = useRef(null);

    // Project and Proposal IDs
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);

    // Data states
    const [chitthiData, setChitthiData] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Area Filter States
    const [availableAreas, setAvailableAreas] = useState([]);
    const [selectedArea, setSelectedArea] = useState('All');

    // Pagination (4 chitthi per page)
    const [currentPage, setCurrentPage] = useState(0);
    const chitthiPerPage = 4;

    // Edit date states
    const [editingDateIndex, setEditingDateIndex] = useState(null);
    const [editDateValue, setEditDateValue] = useState('');

    // Get Project and Proposal IDs
    useEffect(() => {
        const getProjectInfo = () => {
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return project.project_id || project.id;
                } catch (e) {
                    console.error('Error parsing selectedProject:', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return user.data?.project_id || user.project_id;
                } catch (e) {
                    console.error('Error parsing userData:', e);
                }
            }
            return null;
        };

        const getProposalInfo = () => {
            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return user?.data?.default_proposal || user?.data?.proposal_id || user?.default_proposal || user?.proposal_id || null;
                } catch (e) {
                    console.error('Error parsing userData for proposal:', e);
                }
            }
            return null;
        };

        setCurrentProjectId(getProjectInfo());
        setCurrentProposalId(getProposalInfo());
    }, []);

    // Fetch Chitthi Data
    useEffect(() => {
        if (currentProjectId && currentProposalId) {
            fetchChitthiData();
        }
    }, [currentProjectId, currentProposalId]);

    // Reset pagination when filter changes
    useEffect(() => {
        setCurrentPage(0);
    }, [selectedArea]);

    const fetchChitthiData = async () => {
        try {
            setLoading(true);
            const response = await apiService.getRehabA(currentProjectId, currentProposalId);

            console.log("✅ Chitthi API Response:", response);

            // 1. Filter out unallotted plots (Must have owner_name)
            const allottedPlots = response.filter(item => item.owner_name && item.owner_name.trim() !== '');

            // 2. Transform data for chitthi
            const transformedData = allottedPlots.map((item, index) => ({
                id: item.rehab_id,
                chitthiNo: index + 1,
                plotNo: item.plot_no,
                plotSize: item.plot_size,
                areaSqMtr: item.area_sq_mtr,
                date: item.latter_date || new Date().toISOString().split('T')[0],
                villageName: item.village_name,
                talukaName: item.taluka_name,
                districtName: item.district_name,
                baseVillageName: item.base_village_name,
                baseTalukaName: item.base_taluka_name,
                baseDistrictName: item.base_district_name,
                ownerName: item.owner_name
            }));

            // 3. Extract unique areas for the filter tabs (e.g., 370, 555, 740)
            const uniqueAreas = [...new Set(transformedData.map(item => Number(item.areaSqMtr)))].sort((a, b) => a - b);
            
            setAvailableAreas(uniqueAreas);
            setChitthiData(transformedData);
        } catch (error) {
            console.error('Error fetching chitthi data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Derived state for currently filtered data
    const filteredChitthiData = selectedArea === 'All' 
        ? chitthiData 
        : chitthiData.filter(item => Number(item.areaSqMtr) === Number(selectedArea));

    // Calculate total pages based on FILTERED data
    const totalPages = Math.ceil(filteredChitthiData.length / chitthiPerPage);

    // Get current page chitthi (4 per page)
    const getCurrentPageChitthi = () => {
        const startIndex = currentPage * chitthiPerPage;
        const endIndex = startIndex + chitthiPerPage;
        return filteredChitthiData.slice(startIndex, endIndex);
    };

    // Handle date edit
    const handleEditDate = (index) => {
        setEditingDateIndex(index);
        setEditDateValue(filteredChitthiData[index].date);
    };

    const handleSaveDate = async () => {
        if (editingDateIndex === null) return;

        try {
            const chitthi = filteredChitthiData[editingDateIndex];

            const payload = {
                latter_date: editDateValue
            };

            await apiService.patchUpdateRehabA(chitthi.id, payload);

            // update UI after success
            const updatedData = [...chitthiData];
            const originalIndex = updatedData.findIndex(item => item.id === chitthi.id);
            if (originalIndex !== -1) {
                updatedData[originalIndex].date = editDateValue;
            }
            
            setChitthiData(updatedData);
            setEditingDateIndex(null);
            setEditDateValue('');
            alert('दिनांक यशस्वीरीत्या जतन करण्यात आली आहे');

        } catch (error) {
            console.error('❌ Date update failed:', error);
            alert('दिनांक अपडेट करण्यात अडचण आली');
        }
    };

    const handleCancelEdit = () => {
        setEditingDateIndex(null);
        setEditDateValue('');
    };

    // Format date to Marathi
    const formatMarathiDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Handle Print
    const handlePrint = () => {
        const printContent = printRef.current?.innerHTML;
        if (!printContent) {
            alert("No content available to print.");
            return;
        }

        const win = window.open("", "", "height=900,width=1200");
        win.document.write(`
      <html>
        <head>
          <title>भूखंडवाटपाची चिट्ठी</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0;
            }
            
            body {
              font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
              font-size: 13px;
              line-height: 1.4;
              color: #000;
              margin: 0;
              padding: 0;
            }

            .page {
              width: 210mm;
              height: 297mm;
              padding: 10mm;
              box-sizing: border-box;
              page-break-after: always;
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: 1fr 1fr;
              gap: 5mm;
            }

            .page:last-child {
              page-break-after: auto;
            }

            .chitthi-box {
              border: 2px solid #000;
              padding: 8px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              box-sizing: border-box;
            }

            .no-print {
              display: none !important;
            }

            @media print {
              body {
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
              }
              
              .no-print {
                display: none !important;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

        win.document.close();
        win.print();
    };

    // Handle pagination
    const handlePrevious = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const currentPageChitthi = getCurrentPageChitthi();

    return (
        <div className="max-w-7xl mx-auto p-6">
            
            {/* Area Wise Filters */}
            {!loading && chitthiData.length > 0 && (
                <div className="flex flex-wrap gap-3 mb-6 items-center p-4 bg-white rounded-lg shadow-sm border border-gray-100">
                    <span className="font-semibold text-gray-700">क्षेत्रफळानुसार (Area):</span>
                    <button
                        onClick={() => setSelectedArea('All')}
                        className={`px-4 py-2 rounded-md font-medium transition-colors ${selectedArea === 'All' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                    >
                        सर्व (All)
                    </button>
                    {availableAreas.map(area => (
                        <button
                            key={area}
                            onClick={() => setSelectedArea(area)}
                            className={`px-4 py-2 rounded-md font-medium transition-colors ${selectedArea === area ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                        >
                            {area} चौ.मी.
                        </button>
                    ))}
                </div>
            )}

            {/* Action Buttons */}
            <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-4">
                    <button
                        onClick={handlePrevious}
                        disabled={currentPage === 0}
                        className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
                    >
                        <ChevronLeft size={20} />
                        Previous
                    </button>

                    <span className="text-lg font-semibold">
                        Page {totalPages > 0 ? currentPage + 1 : 0} of {totalPages} ({filteredChitthiData.length} चिट्ठी)
                    </span>

                    <button
                        onClick={handleNext}
                        disabled={currentPage >= totalPages - 1}
                        className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
                    >
                        Next
                        <ChevronRight size={20} />
                    </button>
                </div>

                <button
                    onClick={handlePrint}
                    disabled={filteredChitthiData.length === 0}
                    className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg disabled:bg-gray-400"
                >
                    <Printer size={20} />
                    Print Current Group
                </button>
            </div>

            {/* Loading State */}
            {loading && (
                <div className="text-center py-10">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Loading चिट्ठी...</p>
                </div>
            )}

            {/* Chitthi Preview - 4 per page in 2x2 grid */}
            {!loading && filteredChitthiData.length > 0 && (
                <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
                    <div
                        ref={printRef}
                        style={{
                            fontFamily: "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif",
                        }}
                    >
                        {/* Generate pages with 4 chitthi each */}
                        {Array.from({ length: totalPages }).map((_, pageIndex) => {
                            const pageChitthi = filteredChitthiData.slice(
                                pageIndex * chitthiPerPage,
                                (pageIndex + 1) * chitthiPerPage
                            );

                            return (
                                <div
                                    key={pageIndex}
                                    className="page"
                                    style={{
                                        display: pageIndex === currentPage ? 'grid' : 'none',
                                        width: '297mm',
                                        height: '210mm',
                                        padding: '8mm',
                                        boxSizing: 'border-box',
                                        gridTemplateColumns: '1fr 1fr',
                                        gridTemplateRows: '1fr 1fr',
                                        gap: '8mm'
                                    }}
                                >
                                    {pageChitthi.map((chitthi, index) => {
                                        const globalIndex = pageIndex * chitthiPerPage + index;
                                        return (
                                            <div
                                                key={chitthi.id}
                                                className="chitthi-box"
                                                style={{
                                                    border: '3px solid #000',
                                                    padding: '12px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'space-between',
                                                    fontSize: '13px',
                                                    lineHeight: '1.6'
                                                }}
                                            >
                                                <div>
                                                    {/* LINE 1 — CENTER (BASE VILLAGE + STATIC TEXT) */}
                                                    <div
                                                        style={{
                                                            textAlign: 'center',
                                                            fontSize: '13px',
                                                            marginBottom: '6px'
                                                        }}
                                                    >
                                                        मौजे {chitthi.baseVillageName} ता. {chitthi.baseTalukaName}  जि. {chitthi.baseDistrictName} येथील प्रकल्पग्रस्तांना भूखंड वाटप.
                                                    </div>

                                                    {/* LINE 2 — CENTER (NEW RESETTLEMENT VILLAGE) */}
                                                    <div
                                                        style={{
                                                            textAlign: 'center',
                                                            fontSize: '13px',
                                                            marginBottom: '6px'
                                                        }}
                                                    >
                                                        नवीन पुनर्वसित गावठाण – मौजे {chitthi.villageName} ता. {chitthi.talukaName} जि. {chitthi.districtName}
                                                    </div>

                                                    {/* LINE 3 — OWNER NAME (NEW ADDITION) */}
                                                

                                                    {/* LINE 4 — DATE (CENTER, EDITABLE) */}
                                                    <div
                                                        style={{
                                                            textAlign: 'center',
                                                            fontSize: '13px',
                                                            marginBottom: '10px'
                                                        }}
                                                    >
                                                        {editingDateIndex === globalIndex ? (
                                                            <span className="no-print">
                                                                दिनांक :
                                                                <input
                                                                    type="date"
                                                                    value={editDateValue}
                                                                    onChange={(e) => setEditDateValue(e.target.value)}
                                                                    style={{ marginLeft: '6px', fontSize: '12px', border: '1px solid #ccc', padding: '2px' }}
                                                                />
                                                                <button onClick={handleSaveDate} style={{marginLeft: '4px', color: 'green'}}><Save size={16} /></button>
                                                                <button onClick={handleCancelEdit} style={{marginLeft: '4px', color: 'red'}}><X size={16} /></button>
                                                            </span>
                                                        ) : (
                                                            <>
                                                                दिनांक : {formatMarathiDate(chitthi.date)}
                                                                <button
                                                                    onClick={() => handleEditDate(globalIndex)}
                                                                    className="no-print"
                                                                    style={{ marginLeft: '6px', color: 'gray' }}
                                                                >
                                                                    <Edit2 size={14} />
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>

                                                    {/* LINE 5 — BIG BOLD CENTER (PLOT + AREA) */}
                                                    <div style={{ textAlign: 'center', margin: '10px 0' }}>
                                                        <div style={{ fontSize: '26px', fontWeight: 'bold' }}>
                                                            भूखंड क्रमांक {chitthi.plotNo} क्षेत्रफळ {Number(chitthi.areaSqMtr).toFixed(0)} चौ.मी.
                                                        </div>
                                                    </div>
                                                        <div
                                                        style={{
                                                            textAlign: 'center',
                                                            fontSize: '14px',
                                                            // fontWeight: 'bold',
                                                            marginTop: '8px',
                                                            marginBottom: '1px'
                                                        }}
                                                    >
                                                        प्रकल्पग्रस्ताचे नाव: {chitthi.ownerName}
                                                    </div>
                                                </div>


                                                {/* Bottom: Left and Right Side Static Text */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginTop: '20px',
                                                    fontSize: '12px'
                                                }}>
                                                    {/* Left Side */}
                                                    <div style={{ textAlign: 'left' }}>
                                                        <div>भूखंड घेणाऱ्याची सही/अंगठा</div>
                                                    </div>

                                                    {/* Right Side */}
                                                    <div style={{ textAlign: 'right' }}>
                                                        जिल्हा पुनर्वसन अधिकारी
                                                        <div style={{ textAlign: 'center', marginTop: '4px' }}>
                                                            {chitthi.district_name || "बुलढाणा"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    {/* Fill empty slots if less than 4 chitthi on last page */}
                                    {pageChitthi.length < 4 &&
                                        Array.from({ length: 4 - pageChitthi.length }).map((_, i) => (
                                            <div
                                                key={`empty-${i}`}
                                                style={{
                                                    border: '2px dashed #ccc',
                                                    padding: '8px'
                                                }}
                                            />
                                        ))}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* No Data State */}
            {!loading && filteredChitthiData.length === 0 && (
                <div className="text-center py-10 bg-white shadow-sm rounded-lg mt-4 border border-gray-100">
                    <p className="text-gray-600 text-lg font-medium">कोणतीही चिट्ठी उपलब्ध नाही (No allotted plots found for this selection)</p>
                </div>
            )}

        </div>
    );
};

export default PlotAllotmentLetter;